export const getSavedState = (key) => {
  return JSON.parse(window.localStorage.getItem(key));
};

export const saveState = (key, state) => {
  window.localStorage.setItem(key, JSON.stringify(state));
};

export const isIE = () => {
  var ua = navigator.userAgent;
  var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

  return is_ie;
};
